import styled, { css } from 'styled-components';

import { ReactComponent as Arrow } from '../../../../assets/images/blueTheme/chevronArrow.svg';
import { Badge } from '../..';

export const StyledSelectWrapper = styled.div`
  padding: 0 ${({ theme }): string => theme.spacers!.spacer04};
  max-height: 200px;
  overflow: auto;
`;

export const StyledSelectAccordion = styled.div<{ disabled: boolean }>(
  ({ theme, disabled }) => css`
    cursor: ${disabled ? 'not-allowed' : 'pointer'};
    color: ${disabled ? theme.admanColors!.gray.light.bg3[2] : theme.admanColors!.gray.dark.bg3[0]};
    font-family: InspireTWDC;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 21px;
    display: flex;
    align-items: center;
  `
);

export const BadgeList = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const StyledBadgeWrapper = styled.div(
  ({ theme: { spacers, admanColors } }) => css`
    padding: ${spacers!.spacer01};

    > div {
      background: ${admanColors!.blue.dark.bg1[1]};
      color: ${admanColors!.blue.dark.bg1[0]};
      border: 1px solid ${admanColors!.blue.dark.bg1[2]};
      padding-right: 0;

      > div {
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 450px;
        white-space: nowrap;
      }
    }
  `
);

export const StyledBadge = styled(Badge)(
  ({ theme: { admanColors } }) => css`
    background: ${admanColors!.blue.dark.bg1[1]};
    color: ${admanColors!.blue.dark.bg1[0]};
    border: 1px solid ${admanColors!.blue.dark.bg1[2]};
    padding-right: 0;

    > div {
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 450px;
      white-space: nowrap;
    }
  `
);

export const StyledChevronDown = styled(Arrow)<{ $isOpen: boolean }>(
  ({ theme: { admanColors }, $isOpen }) => css`
    rotate: ${$isOpen ? '270deg' : '180deg'};

    path {
      fill: ${admanColors!.gray.light.fg1[0]};
    }
  `
);
